<template>
  <div class="today">
  	<h2>{{　selectMonth　}}</h2>
  	<div class="vue_radio">
      <ul class="dateChangeTabs">
        <li class="button" style="text-align: left;"><button v-on:click="getBeforeDates()">＜</button></li> 
        <li id="first" class="label-main" v-on:click="first()">{{ firstDateString }}</li> 
        <li id="second" class="label-main" v-on:click="second()">{{ secondDateString }}</li> 
        <li id="third" class="label-main" v-on:click="third()">{{ thirdDateString }}</li> 
        <li class="button" style="text-align: right;"><button v-on:click="getNextDates()">＞</button></li></ul>
      <div class="contents">
        <div class="pc">
        	<div class="top-contents">
        		<div class="flexbox">
      			  <section class="main">
      			  	<img src="../../assets/price.jpg">
      			    <a v-on:click="getBuyList()" id="shoppingListButton">Shopping list {{ shoppingListString }}</a>
      			  </section>
      			  <section class="side">
      			    <img src="../../assets/price.jpg">
      			    <a href="https://weart-marketing.com/api/7200kcal/calorie.pdf" id="caloryButton">外食カロリー表</a>
      			  </section>
            </div>
          </div>
        </div>
        <div class="sp">
          <div class="top-contents">
            <a v-on:click="getBuyList()">
              <div class="card-content">
                <section class="main">
                  <img src="../../assets/price.jpg">
                </section>
                <section class="side">
                  <div>
                    <p>Shopping list</p>
                    <label>{{ shoppingListString }}</label>
                  </div>
                </section>
              </div>
            </a>
            <a href="https://weart-marketing.com/api/7200kcal/calorie.pdf" >
              <div class="card-content">
                <section class="main">
                  <img src="../../assets/price.jpg">
                </section>
                <section class="side">
                  <p style="color: black; line-height: 60px;">外食カロリー表</p>
                </section>
              </div>
            </a>
          </div>
        </div>
      </div>
      	<div class="second-contents">
      		<h2>本日のレシピ</h2>
      		<p class="t">Totalカロリー: {{ totalCalory }}Kcal</p>
      		<div class="flexbox" v-if="isTodayRecipe">
      			  <section class="flexinner" v-for="recipe of selectRecipes"  :key="recipe">
      			  	<p class="title">{{ recipe.category }}</p>
      			  	<img v-bind:src="recipe.thumbnail">
                <div class="pc">
        			  	<p>{{ recipe.name }}</p>
        			  	<p>{{ recipe.time }}min | {{ recipe.calory }}Kcal</p>
        			    <a v-on:click="detail(recipe.id)" class="recipeButton">Recipe</a>
                </div>
                <div class="sp">
                  <div class="flex-content">
                    <section class="main">
                      <p>{{ recipe.name }}</p>
                      <p>{{ recipe.time }}min | {{ recipe.calory }}Kcal</p>
                    </section>
                    <section class="side">
                      <a v-on:click="detail(recipe.id)" class="recipeButton">Recipe</a>
                    </section>
                  </div>
                </div>
      			  </section>
    			</div>
          <div class="flexbox" v-else>
            <p style="margin: 0 auto;text-align: center;">本日のレシピはありません。</p>
          </div>
      	</div>


<!--
      	<div class="third-contents">
      		<h2>最新の健康コラム</h2>
      		<div class="flexbox">
    			  <section class="main" v-for="article of articles"  :key="article">
    			  	<img v-bind:src="article.thumbnail">
    			  </section>
    			  <section class="side">
    			  	<div class="side-inner" v-for="article of articles"  :key="article">
    			  		<p>{{ article.title }}</p>
    			  		<a target="_blank" href="https://note.com/7200kcal_recipe/n/ne4cba78d68f2" class="articleButton">記事を読む</a>
    			  	</div>
    			  </section>
    			</div>
          <a href="#" class="articleButton" id="allArticle">すべての記事を見る</a>
      	</div>-->

      </div>
   
    </div>
  </div>
</template>
<style scoped>
.today ul{
	padding-left: 0px;
}
.dateChangeTabs li{
	display: inline-block;
	margin-left: 36px;
	margin-right: 36px;
}
.dateChangeTabs button {
	background: transparent;
	font-size: 24px;
	border: 0px;
  text-decoration: none;
}
.main {
}
.side {
}
.main,
.side {
	width: 50%;
}
#first{
  padding: 8px;
  border-radius: 10px;
}
#second{
  padding: 8px;
  border-radius: 10px;
}
#third{
  padding: 8px;
  border-radius: 10px;
}
#caloryButton{
	display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  font-size: 14px;
  margin:5% auto;
  width: 50%;
}
#shoppingListButton{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  border:0px;
  margin:5% auto;
  width: 60%;
}
.recipeButton{
	display: block;
  background:black;
  color: white;
  border-radius: 25px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  border:0px;
  margin:5% auto;
  width: 100px;
}
.articleButton{
		display: block;
  background:black;
  color: white;
  border-radius: 25px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  border:0px;
  margin:5% auto;
  width: 200px;

}
.top-contents img{
	width: 90%;
	padding: 5%;
	border-radius: 50px;
}
.top-contents .card-content {
  background: white;
  border-radius: 50px;
  padding: 8px;
  box-shadow: 10px 10px 10px 10px rgba(0,0,0,0.4);
}
.second-contents img{
	padding: 5%;
    width: 300px;
}
.third-contents img{
	width: 90%;
	padding: 5%;
}
.second-contents .title{
	font-family: 'Pacifico', cursive;
	font-weight: bold;
	text-align: left;
	font-size: 20px;
	padding-left: 5%;
	margin:0px;
}
.third-contents .flexbox .side{
	position: relative;
}
.side-inner {
position: absolute;
  top: 50%; /*親要素を起点に上から50%*/
  left: 50%;  /*親要素を起点に左から50%*/
  transform: translateY(-50%) translateX(-50%); /*要素の大きさの半分ずつを戻す*/
  -webkit-transform: translateY(-50%) translateX(-50%);
}
/* Responsive */
@media ( min-width : 600px ){
    .top-contents .flexbox {
      display: -webkit-flex;
      display: flex;
      margin:0 auto;
      width: 60%;
    }
    .second-contents .flexbox {
      display: -webkit-flex;
      display: flex;
      margin:0 auto;
      justify-content: space-between;
    }
    .third-contents .flexbox{
      display: -webkit-flex;
      display: flex;
      margin:0 auto;
      width: 60%;

    }
}
@media ( max-width : 780px ){
  .dateChangeTabs li{
  margin-left: 0px;
  margin-right: 0px;
}
.today ul {
    font-size: 14px;
}
.top-contents img {
    width: 120px;
    padding: 0%;
    border-radius: 20px;
}
.top-contents .card-content {
  display: flex;
  margin-top: 36px;
  }
  .top-contents .card-content {
    border-radius: 10px;
    margin-left: 8px;
    margin-right: 8px;
  }
  .card-content .side label{
    font-size: 18px;
  }
  .card-content .side label{
    font-size: 12px;
  }
  .second-contents img {
    padding: 0%;
    padding-top: 5%;
    padding-bottom: 5%;
    width: 100%;
}
.second-contents .flex-content{
  display: flex;
}
.second-contents p{
  text-align: left;
}
.second-contents .main{
  padding: 8px;
}
.second-contents .side{
  margin:auto;
}
.third-contents .main, .third-contents .side {
    width: 100%;
}
.third-contents .side-inner{
  margin-top: 36px;
}
.third-contents #allArticle{
  margin-top: 100px;
}
.second-contents .t{
  text-align: center;
}
}
</style>
<script>
import $ from 'jquery'
import Loading from '../common/Loading'
import firebase from 'firebase'
export default {
  name: 'Today',
  components: {
  },
  data () {
    return {
      loading: null,
      userId: null,
      firstDate: null,
      secondDate: null,
      thirdDate : null,
      isFirst: true,
      firstDateString: null,
      secondDateString: null,
      thirdDateString: null,
      selectRecipes: [],
      recipes: [],
      articles:[],
      shoppingListString: null,
      totalCalory: 0,
      selectMonth: null,
      isTodayRecipe: false,
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

    }
  },
  methods: {
    getRecipes: function (firstDate, secondDate, endDate) {

      var exist = false
      this.loading = true
      let self = this
      var amount = 0
      var totalKcal = 0
      var db = this.db
      this.recipes = []
      this.selectRecipes = []
      db.collection('recipes').where('date', '>=', firstDate).where('date', '<', this.getTommorrow(endDate)).get().then(function (querySnapshot) {
      	console.log(querySnapshot.docs.length)
        querySnapshot.forEach(function (doc) {
        	exist = true
        	console.log(doc)
        	var hash = {}
        	switch (amount){
			  case 0:
			    hash['category'] = 'Morning'
			    break
			  case 1:
			    hash['category'] = 'Lunch'
			    break
			  case 2:
			    hash['category'] = 'Tea time'
			    break
			  case 3:
			    hash['category'] = 'Dinner'
			    break
			  default:
			    console.log('システムエラー')
			}
			hash['id'] = doc.id
			hash['name'] = doc.get('name')
      if (!doc.get('kcal')) {
        hash['calory'] = 0
      } else {
        hash['calory'] = doc.get('kcal')
      }
      if (!doc.get('time')) {
        hash['time'] = 0
      } else {
        hash['time'] = doc.get('time')
      }
      hash['url'] = '/recipe?userId=' + self.userId + '&recipeId=' + doc.id
	        hash['thumbnail'] = doc.get('thumbnail')
	        self.recipes.push(hash)
	        if (amount === querySnapshot.docs.length-1) {
            /*
	        	self.selectRecipes.push(self.recipes[0])
	        	self.selectRecipes.push(self.recipes[1])
	        	self.selectRecipes.push(self.recipes[2])
	        	self.selectRecipes.push(self.recipes[3])
            self.totalCalory = self.recipes[0].calory + self.recipes[1].calory + self.recipes[2].calory + self.recipes[3].calory
            document.getElementById("first").style.backgroundColor = "black";
            document.getElementById("first").style.color = "white";*/

            /*
            self.noBackground()
            self.first()*/

            if (self.isFirst) {
              self.first()
              self.isFirst = false

            }



	        	self.getAriticles()
	        }
        	amount++
        })
        if (!exist) {
          //alert('レシピは存在しません。')
          self.loading = false
        }
      })
        .catch(function (error) {
          console.log(error)
          alert('レシピの取得に失敗しました。エラーです。')
          self.loading = false
        })
    },
    getAriticles: function () {
      var exist = false
      this.loading = true
      let self = this
      this.articles = []
      var amount = 0
      var db = this.db
      db.collection('articles').limit(1).get().then(function (querySnapshot) {
      	console.log(querySnapshot.docs.length)
        querySnapshot.forEach(function (doc) {
        	exist = true
        	var hash = {}
          hash['id'] = doc.id
          hash['title'] = doc.get('title')
	        hash['thumbnail'] = doc.get('thumbnail')
	        hash['description'] = doc.get('description')
	        hash['url'] = doc.get('url')
	        self.articles.push(hash)
	        if (amount === querySnapshot.docs.length-1) {
            self.getStorageRecipeURLs()
	        }
        	amount++
        })
        if (!exist) {
          alert('レシピは存在しません。')
          self.loading = false
        }
      })
        .catch(function (error) {
          console.log(error)
          alert('レシピの取得に失敗しました。エラーです。')
          self.loading = false
        })
    },
    getStorageRecipeURLs: function () {
      // 表示レシピ個数分繰り返し
      let self = this
      for (let i = 0; i < self.recipes.length; i++) {
        var ref = firebase.storage().ref().child(self.recipes[i].thumbnail)
          ref.getDownloadURL().then((url) => {
            console.log(url)
            self.recipes[i].thumbnail = url
            
        });
      }
      self.loading = false

    },
    getMMDDStringFromDate: function (date) {
      var m = ('00' + (date.getMonth() + 1)).slice(-2)
      var d = ('00' + date.getDate()).slice(-2)
      var result = m + '/' + d
      return result
    },
    getTommorrow: function (date) {
      date.setDate(date.getDate() + 1)
      return date
    },
    getZeroDate: function (date) {
      date.setHours(0)
      date.setMinutes(0)
      date.setSeconds(0)
      date.setMilliseconds(0)
      return date
    },
    getBeforeDates: function () {
    	//前三日間分の表示に切り替える
    	// 今日明日明後日を作成
      let self = this
    	this.firstDate = new Date(this.firstDate.setDate(this.firstDate.getDate() - 3))
    	this.secondDate = new Date(this.secondDate.setDate(this.secondDate.getDate() - 3))
    	this.thirdDate = new Date(this.thirdDate.setDate(this.thirdDate.getDate() - 4))

      var minimumLimitDate = new Date( 2021, 3, 1, 0, 0 )
      if ( this.firstDate < minimumLimitDate &&  this.secondDate < minimumLimitDate && this.thirdDate < minimumLimitDate) {

        alert('2021/04/01以前のレシピ記録は閲覧できません。再度マイページから閲覧しなおしてください。')
        return

      } 

      self.selectMonth = self.months[self.firstDate.getMonth()]

    	console.log('dfewfwefewf')
    	console.log(this.firstDate)
    	console.log(this.secondDate)
    	console.log(this.thirdDate)
    	console.log('dfewfwefewf')

    	
    	// 今日明日明後日を入れる
    	this.firstDateString = this.getMMDDStringFromDate(this.firstDate)
    	this.secondDateString = this.getMMDDStringFromDate(this.secondDate)
    	this.thirdDateString = this.getMMDDStringFromDate(this.thirdDate)
    	//ShoppingListのタイトル
    	this.shoppingListString = this.firstDateString + '~' + this.thirdDateString
    	// 今日明日明後日のレシピ条件を全件取得する
      self.noBackground()
    	this.getRecipes(this.firstDate, this.secondDate, this.thirdDate)
      
      self.first()
    },
    getNextDates: function () {
      let self = this
    	//後三日間分の表示に切り替える
    	this.firstDate = new Date(this.firstDate.setDate(this.firstDate.getDate() + 3))
    	this.secondDate = new Date(this.secondDate.setDate(this.secondDate.getDate() + 3))
    	this.thirdDate = new Date(this.thirdDate.setDate(this.thirdDate.getDate() + 2))

      self.selectMonth = self.months[self.thirdDate.getMonth()]


/*
      var minimumLimitDate = new Date( 2031, 4, 1, 0, 0 )
      if ( this.firstDate < minimumLimitDate &&  this.secondDate < minimumLimitDate && this.thirdDate < minimumLimitDate) {

        alert('2031/04/01以前のレシピ記録は閲覧できません。再度マイページから閲覧しなおしてください。')
        location.href = '/mypage?userId=' + self.userId
        return

      } */

    	console.log('dfewfwefewf')
    	console.log(this.firstDate)
    	console.log(this.secondDate)
    	console.log(this.thirdDate)
    	console.log('dfewfwefewf')

    	
    	// 今日明日明後日を入れる
    	this.firstDateString = this.getMMDDStringFromDate(this.firstDate)
    	this.secondDateString = this.getMMDDStringFromDate(this.secondDate)
    	this.thirdDateString = this.getMMDDStringFromDate(this.thirdDate)
    	//ShoppingListのタイトル
    	this.shoppingListString = this.firstDateString + '~' + this.thirdDateString
    	// 今日明日明後日のレシピ条件を全件取得する
      self.noBackground()
    	this.getRecipes(this.firstDate, this.secondDate, this.thirdDate)
      
      self.third()

    },
    noBackground: function () {
      document.getElementById("first").style.backgroundColor = "white";
      document.getElementById("first").style.color = "black";
      document.getElementById("second").style.backgroundColor = "white";
      document.getElementById("second").style.color = "black";
      document.getElementById("third").style.backgroundColor = "white";
      document.getElementById("third").style.color = "black";
    },
    first: function () {
      let self = this
      // 背景に色をつける
      document.getElementById("first").style.backgroundColor = "black";
      document.getElementById("first").style.color = "white";
      document.getElementById("second").style.backgroundColor = "white";
      document.getElementById("second").style.color = "black";
      document.getElementById("third").style.backgroundColor = "white";
      document.getElementById("third").style.color = "black";

      // 最初の日付の情報を表示
      self.selectRecipes = []
      self.totalCalory = 0

      self.selectMonth = self.months[self.firstDate.getMonth()]
      
      if (self.recipes[0] && self.recipes[1] && self.recipes[2] && self.recipes[3]) {
        self.selectRecipes.push(self.recipes[0])
        self.selectRecipes.push(self.recipes[1])
        self.selectRecipes.push(self.recipes[2])
        self.selectRecipes.push(self.recipes[3])
        self.totalCalory = self.recipes[0].calory + self.recipes[1].calory + self.recipes[2].calory + self.recipes[3].calory
        self.isTodayRecipe = true

      } else {
        self.isTodayRecipe = false
      }


    },
    second: function () {
      let self = this

      document.getElementById("first").style.backgroundColor = "white";
      document.getElementById("first").style.color = "black";
      document.getElementById("second").style.backgroundColor = "black";
      document.getElementById("second").style.color = "white";
      document.getElementById("third").style.backgroundColor = "white";
      document.getElementById("third").style.color = "black";

      console.log('dweufhdeiudiwedwedw')
      console.log(self.recipes)
      console.log('dweufhdeiudiwedwedw')

      self.selectMonth = self.months[self.secondDate.getMonth()]

      // 二番目の日付の情報を表示
      self.selectRecipes = []
      self.totalCalory = 0
      if (self.recipes[4] && self.recipes[5] && self.recipes[6] && self.recipes[7]) {
        self.selectRecipes.push(self.recipes[4])
        self.selectRecipes.push(self.recipes[5])
        self.selectRecipes.push(self.recipes[6])
        self.selectRecipes.push(self.recipes[7])
        self.totalCalory = self.recipes[4].calory + self.recipes[5].calory + self.recipes[6].calory + self.recipes[7].calory
        self.isTodayRecipe = true
      } else {
        self.isTodayRecipe = false
      }

    },
    third: function () {
      let self = this

      document.getElementById("first").style.backgroundColor = "white";
      document.getElementById("first").style.color = "black";
      document.getElementById("second").style.backgroundColor = "white";
      document.getElementById("second").style.color = "black";
      document.getElementById("third").style.backgroundColor = "black";
      document.getElementById("third").style.color = "white";

      // 三番目の日付の情報を表示
      self.selectRecipes = []
      self.totalCalory = 0

      self.selectMonth = self.months[self.thirdDate.getMonth()]


      if (self.recipes[8] && self.recipes[9] && self.recipes[10] && self.recipes[11]) {
        self.selectRecipes.push(self.recipes[8])
        self.selectRecipes.push(self.recipes[9])
        self.selectRecipes.push(self.recipes[10])
        self.selectRecipes.push(self.recipes[11])
        self.totalCalory = self.recipes[8].calory + self.recipes[9].calory + self.recipes[10].calory + self.recipes[11].calory
        self.isTodayRecipe = true
      } else {
        self.isTodayRecipe = false
      }

      
    },
    getBuyList: function () {
      location.href='/list?startYear=' + this.firstDate.getFullYear() + '&startMonth=' + this.firstDate.getMonth() + '&startDate=' + this.firstDate.getDate() + '&endYear=' + this.thirdDate.getFullYear() + '&endMonth=' + this.thirdDate.getMonth() +'&endDate=' + this.thirdDate.getDate() + '&userId=' + this.userId
    },
    detail: function (id) {
      location.href='/recipe?startYear=' + this.firstDate.getFullYear() + '&startMonth=' + this.firstDate.getMonth() + '&startDate=' + this.firstDate.getDate() + '&endYear=' + this.thirdDate.getFullYear() + '&endMonth=' + this.thirdDate.getMonth() +'&endDate=' + this.thirdDate.getDate() + '&userId=' + this.userId + '&recipeId=' + id
    }
  },
  created: function () {

  	this.db = firebase.firestore()
    // Planを取得
    if (!localStorage.userId) {
      alert('ユーザーが存在しません、。再度ログインしなおしてください。')
      location.href='/'
    } else {


      var url = location.search.substring(1)
      var parameters = url.split('&')
      var result = Object()
      for (var i = 0; i < parameters.length; i++) {
        var element = parameters[i].split('=')
        var paramName = decodeURIComponent(element[0])
        var paramValue = decodeURIComponent(element[1])
        result[paramName] = decodeURIComponent(paramValue)
      }


      this.userId = result['userId']
      var startYear = parseInt(result['startYear'], 10)
      var startMonth = parseInt(result['startMonth'], 10)
      var startDate = parseInt(result['startDate'], 10)
      this.firstDate = new Date(startYear, startMonth, startDate, 0, 0, 0)
      this.selectMonth = this.months[startMonth]
      this.secondDate = new Date(startYear, startMonth, startDate+1, 0, 0, 0)
      this.thirdDate = new Date(startYear, startMonth, startDate+2, 0, 0, 0)

      // 今日明日明後日を入れる
      this.firstDateString = this.getMMDDStringFromDate(this.firstDate)
      this.secondDateString = this.getMMDDStringFromDate(this.secondDate)
      this.thirdDateString = this.getMMDDStringFromDate(this.thirdDate)

      //ShoppingListのタイトル
      this.shoppingListString = this.firstDateString + '~' + this.thirdDateString
      // 今日明日明後日のレシピ条件を全件取得する
      this.getRecipes(this.firstDate, this.secondDate, this.thirdDate)
    }

    
    
  },
  mounted: function () {
    document.getElementById("first").style.backgroundColor = "black";
    document.getElementById("first").style.color = "white";
  }
}
</script>



// WEBPACK FOOTER //
// src/components/today/Today.vue